module.exports = __webpack_public_path__ + "img/TZ.226a3f73.svg";